// extracted by mini-css-extract-plugin
module.exports = {"container":"dF-z","disabled":"eF-z","remove":"fF-z"};